import styled from 'styled-components';
import { TrimCarouselStyled } from '../TrimCarouselStyled';
import media from '../../../styles/media';
import { rem } from 'polished';

export const TrimCarouselStyledAC = styled(TrimCarouselStyled)`
    .trimItemWrap {
        box-sizing: border-box;
        border-radius:  ${rem(12)};

        & > div {
            padding: ${rem('13px')};
        }
    }
    .carouselArrows-wrapper {
        position: absolute;
        top: 0;
        text-align: right;
        display: flex;
        justify-content: space-between;
        width: 100%;

        ${media.lg`
            width: 100%;
            left: 0;
        `}

        &__btnsSection {
            .arrowBtn {
                background-color: ${({ theme }) => theme.colors.white};
                border: 2px solid ${({ theme }) => theme.colors.red};
                border-radius: ${rem(10)};

                .icon-wrapper {
                    svg {
                        path {
                            stroke: ${({ theme }) => theme.colors.red};
                        }
                    }
                }

                &:not(&--disabled) {
                    :hover {
                        background-color: ${({ theme }) => theme.colors.white};
                        border: 2px solid ${({ theme }) => theme.colors.grey5};

                        .icon-wrapper {
                            svg {
                                path {
                                    stroke: ${({ theme }) => theme.colors.grey5};
                                }
                            }
                        }
                    }
                }

                &--disabled {
                    pointer-events: none;
                    background-color: ${({ theme }) => theme.colors.white};
                    border: none;

                    border: 2px solid ${({ theme }) => theme.colors.grey5};
                    opacity: 0.2;

                    .icon-wrapper {
                        svg {
                            path {
                                stroke: ${({ theme }) => theme.colors.grey5};
                            }
                        }
                    }
                }
            }
        }
    }
`;
